// @ts-strict-ignore
import questionIcon from '@/assets/svg/question.svg'
import clsx from 'clsx'
import { memo } from 'react'

import { Icon } from '@/shared/ui/icon'
import { Popover } from '@/shared/ui/Popover'

import { TotalProductSet } from '../MUST_BE_REFACTORED/TotalProductSet/TotalProductSet'

import { Price } from './Price/Price'
import { PricesBlockLoader } from './PricesBlockLoader'

import cl from './prices-block.module.scss'

interface PricesBlockProps {
	currentPrice: number
	oldPrice?: number
	discountedPrice?: number
	isLoading?: boolean
}

export const PricesBlock = memo((props: PricesBlockProps) => {
	const { discountedPrice, currentPrice, oldPrice, isLoading } = props

	if (isLoading) return <PricesBlockLoader />

	// note: (discountedPrice < currentPrice) will be true if discounted is null!
	// so before that we need to check discountedPrice for falsy value
	const showDiscounted = discountedPrice && discountedPrice < currentPrice

	const rootClasses = clsx(cl.root, {
		[cl.root__discounted]: showDiscounted
	})

	const Regular = () => (
		<div className={cl.regular}>
			<Price price={currentPrice} />
			{oldPrice && <Price price={oldPrice} isOld />}
		</div>
	)

	const Discounted = () => (
		<>
			<div className={cl.discounted}>
				<Price price={discountedPrice} className={cl.discounted__price} />
				<span className={cl.discounted__text}>с учетом акций</span>
				<BonusesPopover />
			</div>
			<div className={cl.otherPrices}>
				<Price price={currentPrice} className={cl.current} />
				{oldPrice && <Price price={oldPrice} isOld />}
			</div>
		</>
	)

	return (
		<div className={rootClasses}>
			{showDiscounted ? <Discounted /> : <Regular />}
			<div className={cl.totalProductSetWrapper}>
				<TotalProductSet />
			</div>
		</div>
	)
})

const BonusesPopover = () => (
	<div className={cl.popover}>
		<Popover
			overlayInnerStyle={{ maxWidth: `25rem` }}
			content={<div className={cl.popoverContent}>Оплатите покупку бонусами при оформлении заказа</div>}>
			<Icon icon={questionIcon} width={16} height={16} />
		</Popover>
	</div>
)
